import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// 1. Ant Design
import { Button, Space, Table, Tag, Typography } from "antd";
// 2. External libraries
import { observer } from "mobx-react-lite";
// 5. Types, utils, styles
import { INVOICE_STATUS_COLORS, INVOICE_VOID_LABEL, PAYMENT_STATE_COLORS, PAYMENT_STATE_LABELS } from "@/types/company/settlements.common";
import { formatDate, formatMoney } from "./format";
import styles from "@/styles/Company/Settlements.module.less";
const { Text } = Typography;
/** Таблица счетов компании (UC1120 §2.2, `v_corp_invoices`). */
const InvoicesTable = observer(({ invoices, loading, onOpenLines, onVoidInvoice, onExternalDoc }) => {
    const columns = [
        {
            title: "Номер",
            key: "number",
            render: (_, invoice) => invoice.number,
        },
        {
            title: "Период",
            key: "period",
            render: (_, invoice) => `${formatDate(invoice.periodStart)} – ${formatDate(invoice.periodEnd)}`,
        },
        {
            title: "Выставлен",
            key: "issueDate",
            render: (_, invoice) => formatDate(invoice.issueDate),
        },
        {
            title: "Срок",
            key: "dueDate",
            render: (_, invoice) => formatDate(invoice.dueDate),
        },
        {
            title: "Итог ₽",
            key: "total",
            render: (_, invoice) => formatMoney(invoice.total),
        },
        {
            title: "Оплачено ₽",
            key: "paidAmount",
            render: (_, invoice) => invoice.paidAmount === null ? _jsx(Text, { type: "secondary", children: "\u2014" }) : formatMoney(invoice.paidAmount),
        },
        {
            title: "Состояние",
            key: "status",
            render: (_, invoice) => invoice.status === "VOID" ? (_jsx(Tag, { color: INVOICE_STATUS_COLORS.VOID, children: INVOICE_VOID_LABEL })) : invoice.paymentState ? (_jsx(Tag, { color: PAYMENT_STATE_COLORS[invoice.paymentState], children: PAYMENT_STATE_LABELS[invoice.paymentState] })) : (_jsx(Text, { type: "secondary", children: "\u2014" })),
        },
        {
            title: "Дней просрочки",
            key: "daysOverdue",
            render: (_, invoice) => invoice.daysOverdue ?? _jsx(Text, { type: "secondary", children: "\u2014" }),
        },
        {
            title: "Внешний документ",
            key: "externalDoc",
            render: (_, invoice) => invoice.externalDocNumber
                ? `${invoice.externalDocNumber} · ${formatDate(invoice.externalDocDate)}`
                : _jsx(Text, { type: "secondary", children: "\u2014" }),
        },
        {
            title: "Действия",
            key: "actions",
            render: (_, invoice) => (_jsxs(Space, { size: 4, wrap: true, children: [_jsx(Button, { size: "small", onClick: () => onOpenLines(invoice), children: "\u0421\u0442\u0440\u043E\u043A\u0438" }), invoice.status === "ISSUED" && onExternalDoc ? (_jsx(Button, { size: "small", "data-testid": "corp-invoice-external-doc", onClick: () => onExternalDoc(invoice), children: "\u0412\u043D\u0435\u0448\u043D\u0438\u0439 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442" })) : null, invoice.status === "ISSUED" && onVoidInvoice ? (_jsx(Button, { size: "small", danger: true, "data-testid": "corp-settlements-void-invoice", onClick: () => onVoidInvoice(invoice), children: "\u0410\u043D\u043D\u0443\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C" })) : null] })),
        },
    ];
    return (_jsx("div", { "data-testid": "corp-settlements-invoices-table", children: _jsx(Table, { rowKey: "invoiceId", size: "middle", columns: columns, dataSource: invoices, loading: loading, pagination: invoices.length > 20 ? { pageSize: 20 } : false, scroll: { x: 1200 }, rowClassName: (invoice) => (invoice.isOverdue ? styles.invoiceOverdue : ""), onRow: (invoice) => ({
                "data-testid": invoice.isOverdue ? `corp-settlements-invoice-${invoice.invoiceId}-overdue` : undefined,
            }), locale: { emptyText: "Счетов пока нет" } }) }));
});
InvoicesTable.displayName = "InvoicesTable";
export default InvoicesTable;
